<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="loginForm.email"
                      type="email"
                      required
                      class="form-control"
                      placeholder="E-Mail"
                      autocomplete="username email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="loginForm.password"
                      :type="pwdType"
                      required
                      class="form-control"
                      placeholder="Password"
                      autocomplete="current-password"
                      v-on:keyup.enter="handleLogin"
                    />
                    <b-input-group-append>
                      <b-input-group-text><a v-on:click="toggleShowPassword"><i v-bind:class="[pwdType === 'password' ? 'fa fa-eye-slash' : 'fa fa-eye']" aria-hidden="true"></i></a></b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button v-if="!loading" variant="primary" class="px-4" v-on:click="handleLogin">Login</b-button>
                      <b-button v-if="loading" variant="primary" class="px-4" disabled>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        Loading...
                      </b-button>
                    </b-col>
                    <!--<b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0">Forgot password?</b-button>
                    </b-col>-->
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <!--<b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card>-->
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {
                loginForm: {
                    email: '',
                    password: '',
                },
                loading: false,
                pwdType: 'password',
                redirect: undefined,
            };
        },
        watch: {
            $route: {
                handler: function (route) {
                    this.redirect = route.query && route.query.redirect;
                },
                immediate: true,
            },
        },
        methods: {
            toggleShowPassword() {
                if (this.pwdType === 'password') {
                    this.pwdType = 'text';
                } else {
                    this.pwdType = 'password';
                }
            },
            handleLogin() {
                if (!this.loading) {
                this.loading = true;
                this.$store.dispatch('user/login', this.loginForm)
                    .then(() => {
                        this.$router.push({path: this.redirect || '/'});
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
                }
            }
        }

    }
</script>
